import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { EmotionalStory } from '../components/EmotionalStory';
import { BenefitsSection } from '../components/BenefitsSection';
import { BundleSection } from '../components/BundleSection';
import { BonusSection } from '../components/BonusSection';
import { TargetAudience } from '../components/TargetAudience';
import { PricingCTA } from '../components/PricingCTA';
import { TestimonialFooter } from '../components/TestimonialFooter';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-cream" data-id="element-217">
      <HeroSection data-id="element-218" />
      <EmotionalStory data-id="element-219" />
      <BenefitsSection data-id="element-220" />
      <BundleSection data-id="element-221" />
      <BonusSection data-id="element-222" />
      <TargetAudience data-id="element-223" />
      <PricingCTA data-id="element-224" />
      <TestimonialFooter data-id="element-225" />
    </main>;
}